export const validateInput = (type, value, countryCodeValue) => {
  const errors = {};
  const namePattern = /^[a-zA-Z\s\-]+$/;

  switch (type) {
    case "email":
      if (!value) {
        errors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(value)) {
        errors.email = "Email address is invalid";
      }
      break;

    case "assessmentName":
      if (!value) {
        errors.assessmentName = "Assessment name is required";
      } else if (!/^[A-Za-z0-9 ]*$/.test(value)) {
        errors.assessmentName = "Assessment name is Invalid";
      }
      break;

    case "password":
      if (!value) {
        errors.password = "Password is required";
      }
      break;

       case "mobileNumber":
      console.log("Selected countryCodeValue:", countryCodeValue);
      if (!value) {
        errors.mobileNumber = "Mobile number is required";
      } else if (countryCodeValue?.digit_length) {
        const expectedLength = countryCodeValue.digit_length;
        if (value.length !== expectedLength) {
          errors.mobileNumber = `Mobile number must be ${expectedLength} digits for ${countryCodeValue.value}`;
        }
      }
      break;
      
    case "linkedInProfileLink":
      const urlPattern =
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
      if (!value) {
        errors.linkedInProfileLink = "LinkedIn Profile Link is required";
      } else if (!urlPattern.test(value)) {
        errors.linkedInProfileLink = "LinkedIn Profile Link is invalid";
      }
      break;

    case "user_name":
      if (!value) {
        errors.user_name = "Name is required";
      } else if (!namePattern.test(value)) {
        errors.user_name = "Name must contain only letters, spaces, or hyphens";
      }
      break;

    case "companyName":
      if (!value) {
        errors.companyName = "Company Name is required";
      } else if (!/^[A-Za-z0-9 ]*$/.test(value)) {
        errors.companyName =
          "Company Name is Invalid";
      }
      break;

    case "newCompanyName":
      if (!value || !value?.label) {
        errors.newCompanyName = "Company Name is required";
      } else if (!/^[A-Za-z0-9 ]*$/.test(value.label)) {
        errors.newCompanyName =
          "Company Name is Invalid";
      }
      break;

    case "keyContactName":
      if (!value) {
        errors.keyContactName = "Key Contact Name is required";
      } else if (!namePattern.test(value)) {
        errors.keyContactName =
          "Key Contact Name must contain only letters, spaces, or hyphens";
      }
      break;

    // Generic validation for any type of input (e.g., employee ID, username, etc.)
    default:
      if (!value) {
        errors[type] = `${
          type.charAt(0).toUpperCase() + type.slice(1)
        } is required`;
      }
      break;
  }

  return errors;
};

//To validate two passwords
export const validatePasswords = (password, confirmPassword) => {
  let errors = {};

  if (!password) {
    errors.password = "Password is required.";
  } else if (password.length < 8) {
    errors.password = "Password must be at least 8 characters.";
  }

  if (!confirmPassword) {
    errors.confirmPassword = "Please confirm your password.";
  } else if (password !== confirmPassword) {
    errors.confirmPassword = "Passwords do not match.";
  }

  return errors;
};

// To validate current and new password
export function validateCurrentAndNewPassword(currentPassword, newPassword) {
  let errors = {};

  // Check if the new password is different from the current password
  if (currentPassword === newPassword) {
    errors.password =
      "New password cannot be the same as the current password.";
  }

  // If all validations pass
  return errors;
}


//countries and code are update from the api
export const COUNTRIES = [
        {
            "country_id": 1,
            "country_name": "UAE",
            "country_code": "+971",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/1a05df6d-b768-4052-b140-16ea53ba7298---dubai.svg",
            "digit_length": 9,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2024-07-17T04:12:27.000Z",
            "updatedAt": "2025-04-24T03:45:20.000Z"
        },
        {
            "country_id": 2,
            "country_name": "India",
            "country_code": "+91",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/8bfedbdb-c8cc-4607-a1f6-58cbcce485c5---india.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2024-07-17T04:12:27.000Z",
            "updatedAt": "2025-04-24T03:45:21.000Z"
        },
        {
            "country_id": 3,
            "country_name": "Saudi",
            "country_code": "+966",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/69f21916-8569-4e11-b1d0-720510c88cd1---saudi.svg",
            "digit_length": 9,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2024-07-17T04:12:27.000Z",
            "updatedAt": "2025-04-24T03:45:21.000Z"
        },
        {
            "country_id": 4,
            "country_name": "Kenya",
            "country_code": "+254",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/28923411-1bae-43a2-81c1-8305ea0e8980---Kenya.svg",
            "digit_length": 9,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-04-24T03:19:13.000Z",
            "updatedAt": "2025-04-24T03:43:52.000Z"
        },
        {
            "country_id": 5,
            "country_name": "Pakistan",
            "country_code": "+92",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/c0526574-92c1-4ab3-a45e-122990efd354---Pakistan.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-04-24T03:19:14.000Z",
            "updatedAt": "2025-04-24T03:43:52.000Z"
        },
        {
            "country_id": 6,
            "country_name": "Vietnam",
            "country_code": "+84",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/fc0bc8ac-e9ae-4457-a8d8-e0f4b54b6d3f---Vietnam.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-04-24T03:19:14.000Z",
            "updatedAt": "2025-04-25T06:24:13.000Z"
        },
        {
            "country_id": 7,
            "country_name": "Turkey",
            "country_code": "+90",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/01bef8df-4a91-4a69-bb9a-108c4a50b2b9---Turkey.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-04-24T03:19:15.000Z",
            "updatedAt": "2025-04-24T03:43:51.000Z"
        },
        {
            "country_id": 8,
            "country_name": "Russia",
            "country_code": "+7",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/f9ce6314-b0b0-4532-9b6b-7bd681e7dca4---Russia.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-04-24T03:19:16.000Z",
            "updatedAt": "2025-04-24T03:43:53.000Z"
        },
        {
            "country_id": 9,
            "country_name": "USA",
            "country_code": "+1",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/8c9bcfda-28ac-4f25-8066-8ea0c5f5cb3b---US.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T01:05:10.000Z",
            "updatedAt": "2025-05-13T10:16:08.000Z"
        },
        {
            "country_id": 10,
            "country_name": "Uganda",
            "country_code": "+256",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/e785ce0d-581c-4baf-bb82-442a83ee102e---ug.svg",
            "digit_length": 9,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T01:10:03.000Z",
            "updatedAt": "2025-05-13T10:16:08.000Z"
        },
        {
            "country_id": 11,
            "country_name": "Zambia",
            "country_code": "+260",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/7ae83dad-4143-4d5f-bd37-e4cd44bce154---zm.svg",
            "digit_length": 9,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T01:10:03.000Z",
            "updatedAt": "2025-05-13T10:16:09.000Z"
        },
        {
            "country_id": 12,
            "country_name": "Oman",
            "country_code": "+968",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/e9d79454-1f02-4057-96e3-eba8d8ca97b1---om.svg",
            "digit_length": 8,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T01:10:03.000Z",
            "updatedAt": "2025-05-13T10:16:12.000Z"
        },
        {
            "country_id": 13,
            "country_name": "Bahrain",
            "country_code": "+973",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/de329d74-4772-4787-abad-629b4e1d5f27---bh.svg",
            "digit_length": 8,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T01:10:03.000Z",
            "updatedAt": "2025-05-13T10:16:12.000Z"
        },
        {
            "country_id": 14,
            "country_name": "Qatar",
            "country_code": "+974",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/ff3c2855-8566-409a-9bd7-f41eadc0172a---qa.svg",
            "digit_length": 8,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T01:10:03.000Z",
            "updatedAt": "2025-05-13T10:16:13.000Z"
        },
        {
            "country_id": 15,
            "country_name": "Iraq",
            "country_code": "+964",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/b625f896-3322-490f-9723-7696f4e3be1b---iq.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T01:10:03.000Z",
            "updatedAt": "2025-05-13T10:16:13.000Z"
        },
        {
            "country_id": 16,
            "country_name": "Jordan",
            "country_code": "+962",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/7c9d1430-1bf6-498f-b456-a06d31076834---jo.svg",
            "digit_length": 9,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T02:40:40.000Z",
            "updatedAt": "2025-05-12T05:22:02.000Z"
        },
        {
            "country_id": 17,
            "country_name": "Tanzania",
            "country_code": "+255",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/a16dad11-b06b-4ad7-b9c4-f85bc51d0cab---tz.svg",
            "digit_length": 9,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T02:40:40.000Z",
            "updatedAt": "2025-05-13T10:16:13.000Z"
        },
        {
            "country_id": 18,
            "country_name": "Nigeria",
            "country_code": "+234",
            "country_flag": "https://kg-prod-clone-bucket.s3.ap-south-1.amazonaws.com/8d4fcd55-dd0b-453e-bdde-9d5b5a3f6f9c---ng.svg",
            "digit_length": 10,
            "status": 2,
            "created_by": null,
            "updated_by": null,
            "createdAt": "2025-05-12T02:40:41.000Z",
            "updatedAt": "2025-05-13T10:16:14.000Z"
        }
    ];
export const COUNTRY_PHONE_LENGTHS = {};

export const updateCountryData = (countries, phoneLengths) => {
  if (countries && Object.keys(countries).length > 0) {
    COUNTRIES = { ...countries };
  }
  
  if (phoneLengths && Object.keys(phoneLengths).length > 0) {
    COUNTRY_PHONE_LENGTHS = { ...phoneLengths };
  }
};